import { useEffect } from 'react'
import { path } from 'ramda'

type UseMobilePopupCloseProps = {
  mapRef: React.RefObject<any>
  isMobile: boolean
  buildingDetail: any
  closeMobilePopup: () => void
}

export const useMobilePopupClose = ({
  mapRef,
  isMobile,
  buildingDetail,
  closeMobilePopup
}: UseMobilePopupCloseProps) => {
  // Add direct event listeners to map for immediate mobile popup dismissal on zoom/pan
  useEffect(() => {
    if (!mapRef.current || !isMobile) return

    const map = mapRef.current.getMap()
    if (!map) return

    const handleMoveStart = () => {
      const currentSelectedMobile = path(['0'], buildingDetail)
      if (currentSelectedMobile) {
        closeMobilePopup()
      }
    }

    const handleZoomStart = () => {
      const currentSelectedMobile = path(['0'], buildingDetail)
      if (currentSelectedMobile) {
        closeMobilePopup()
      }
    }

    // Add event listeners for start events
    map.on('movestart', handleMoveStart)
    map.on('zoomstart', handleZoomStart)

    return () => {
      map.off('movestart', handleMoveStart)
      map.off('zoomstart', handleZoomStart)
    }
  }, [mapRef, isMobile, buildingDetail, closeMobilePopup])
}
